import isNode from 'is-node';
import { MobXProviderContext } from 'mobx-react';
import React from 'react';
import BreadcrumbStore from './BreadcrumbStore';
import ContentStore from './ContentStore';
import CookieConsentStore from './CookieConsentStore';
import GaDataStore from './GaDataStore';
import LanguageStore from './LanguageStore';
import MenuStore from './MenuStore';
import RoamingNumberStore from './RoamingNumberStore';
import RouteStore from './RouteStore';
import StoresStore from './StoresStore';
import SsoStore from './SsoStore';
import RoamingStore from './RoamingStore';
import CmsDataStore from './CmsDataStore';
import NewsStore from './NewsStore';
import BillingStore from './BillingStore';
import { RouterStore } from '@superwf/mobx-react-router';
import ContactInfoStore from './ContactInfoStore';

const IS_NODE = isNode;

class RootStore {
  public initialState: InitialState;
  public isNode: boolean;
  public app: App;

  public routing: RouterStore;
  public cookieConsentStore: CookieConsentStore;
  public routeStore: RouteStore;
  public languageStore: LanguageStore;
  public menuStore: MenuStore;
  public contentStore: ContentStore;
  public breadcrumbStore: BreadcrumbStore;
  public newsStore: NewsStore;
  public ssoStore: SsoStore;
  public billingStore: BillingStore;
  public roamingStore: RoamingStore;
  public cmsDataStore: CmsDataStore;
  public gaDataStore: GaDataStore;
  public contactInfoStore: ContactInfoStore;
  public roamingNumberStore: RoamingNumberStore;
  public storesStore: StoresStore;

  constructor(routing: RouterStore, initialState: InitialState, app: App) {
    this.initialState = initialState;
    this.routing = routing;
    this.isNode = IS_NODE;
    this.app = app;
    this.cookieConsentStore = new CookieConsentStore(initialState.cookieConsents);
    this.routeStore = new RouteStore(this);
    this.languageStore = new LanguageStore(this);
    this.menuStore = new MenuStore(this);
    this.contentStore = new ContentStore(this);
    this.breadcrumbStore = new BreadcrumbStore(this);
    this.newsStore = new NewsStore(this);
    this.ssoStore = new SsoStore(this);
    this.roamingStore = new RoamingStore(this);
    this.cmsDataStore = new CmsDataStore();
    this.billingStore = new BillingStore(this);
    this.gaDataStore = new GaDataStore(this);
    this.contactInfoStore = new ContactInfoStore();
    this.roamingNumberStore = new RoamingNumberStore(this);
    this.storesStore = new StoresStore();
  }
}

export function useStores(): RootStore {
  return React.useContext(MobXProviderContext) as RootStore;
}

export default RootStore;
